var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicAnecdotas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FECDD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E11D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BE123C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pageGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F1F5F9"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 34)",
    filter: "drop-shadow(0px 3px 2px rgba(190, 18, 60, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20,6 C-14,8 -6,6 0,0 C6,6 14,8 20,6 L22,-10 C16,-8 8,-10 0,-14 C-8,-10 -16,-8 -22,-10 Z",
    fill: "url(#bookGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19,4 C-13,6 -6,4 0,-1 L-1,-11 C-7,-8 -14,-10 -20,-12 Z",
    fill: "url(#pageGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4 C13,6 6,4 0,-1 L1,-11 C7,-8 14,-10 20,-12 Z",
    fill: "url(#pageGrad)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -7,
    x2: -5,
    y2: -5,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -3,
    x2: -7,
    y2: -1,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: 1,
    x2: -9,
    y2: 3,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -5,
    x2: 15,
    y2: -7,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: -1,
    x2: 15,
    y2: -3,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 3,
    x2: 12,
    y2: 1,
    stroke: "#94A3B8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, -22)",
    filter: "drop-shadow(0px 1px 1px rgba(225, 29, 72, 0.3))"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -6,
    width: 16,
    height: 11,
    rx: 3.5,
    fill: "#FDA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3,5 L -5,8 L -1,5 Z",
    fill: "#FDA4AF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -0.5,
    r: 1.5,
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicAnecdotas);
export default __webpack_public_path__ + "static/media/topic_anecdotas.1afb8540b991d675b19e8adcce8d33e3.svg";
export { ForwardRef as ReactComponent };